// deps
import { IconButton } from "@chakra-ui/react";
import PropTypes from "prop-types";
import { useRef } from "react";

/**
 * @typedef {"previous" | "next"} CANCEL_ICON_BUTTON_LABEL
 */
/**
 * @typedef Props
 * @property {import("react").ReactElement} icon
 * @property {import("@react-stately/calendar").CalendarState} state
 * @property {CANCEL_ICON_BUTTON_LABEL} label
 * @property {import("react").Dispatch<import("react").SetStateAction<any>>} [onChangeMonth]
 * @property {(event: any) => void} [onChangeFocusDate]
 * @property {boolean} [shouldChangeSelectedDateOnChangeMonthOrYear]
 */
/**
 * @param {Props & import("@chakra-ui/react").IconButtonProps } props
 * @returns {import("react").FunctionComponentElement<Props>}
 */
function CalendarIconButton(props) {
  const {
    icon,
    state,
    label,
    onChangeMonth,
    onChangeFocusDate,
    shouldChangeSelectedDateOnChangeMonthOrYear,
    ...otherProps
  } = props;
  const ref = useRef(null);

  const handleClick = () => {
    let newMonth =
      label === "next"
        ? state.focusedDate.add({ months: 1 })
        : state.focusedDate.subtract({ months: 1 });

    // Check if the new month is within the min and max date range
    if (state.minValue && newMonth.compare(state.minValue) < 0) {
      return;
    }
    if (state.maxValue && newMonth.compare(state.maxValue) > 0) {
      return;
    }

    shouldChangeSelectedDateOnChangeMonthOrYear && onChangeMonth?.(newMonth);
    onChangeFocusDate?.(newMonth);
    state.setFocusedDate(newMonth);
  };

  return (
    <IconButton
      {...otherProps}
      ref={ref}
      size="sm"
      icon={icon}
      type="button"
      onClick={handleClick}
    />
  );
}

export default CalendarIconButton;

CalendarIconButton.propsTypes = {
  icon: PropTypes.element,
  state: PropTypes.object,
  type: PropTypes.string,
  onChange: PropTypes.func,
};
